const initInfiniteScroll = () => {
  const container = document.querySelector("#ProductGridContainer")
  if (!container) return

  const resolveGrid = () => {
    const grid = container.querySelector("#product-grid")
    if (!grid) return null
    return grid.tagName === "UL" ? grid : grid.querySelector("ul.product-grid") || grid
  }

  let productGrid = resolveGrid()
  if (!productGrid) return

  let currentPage = 1
  let maxPages = Number(container.querySelector(".eosh-total-pages")?.value)
  let loading = false
  let fetchGeneration = 0

  let hasFeaturedCards = false
  let lastProductOrder = 0

  const initOrderTracking = () => {
    hasFeaturedCards = false
    lastProductOrder = 0
    const firstOrdered = productGrid.querySelector(".grid__item[style*='order']")
    if (!firstOrdered) return
    hasFeaturedCards = true
    productGrid.querySelectorAll(".grid__item:not(.featured-collection-card)").forEach(item => {
      const order = parseInt(item.style.order, 10)
      if (!isNaN(order) && order > lastProductOrder) lastProductOrder = order
    })
  }

  initOrderTracking()

  function notifyDiscountNinjaCollectionUpdated() {
    document.dispatchEvent(new CustomEvent("la:dn:collection:updated"))

    if (window.location.href.includes("sale")) {
      window.discountNinja?.api?.events?.publish("la:dn:collection:updated")
    }
  }

  const filterKey = () => {
    const u = new URL(window.location.href)
    u.searchParams.delete("page")
    return u.toString()
  }

  const loadNextPage = async () => {
    if (loading || currentPage >= maxPages) return

    loading = true
    const myGeneration = ++fetchGeneration
    const nextPage = currentPage + 1
    const url = new URL(window.location.href)
    url.searchParams.set("page", nextPage)
    const keyAtStart = filterKey()

    try {
      const response = await fetch(url)
      if (filterKey() !== keyAtStart) return // filter changed mid-fetch, discard
      const html = await response.text()
      const tempDiv = document.createElement("div")
      tempDiv.innerHTML = html

      const newProducts = tempDiv.querySelectorAll(
        "#ProductGridContainer li.grid__item:not(.featured-collection-card)"
      )

      if (newProducts.length) {
        const fragment = document.createDocumentFragment()
        newProducts.forEach(p => {
          if (hasFeaturedCards) {
            lastProductOrder += 100
            p.style.order = lastProductOrder
          }
          p.classList.add("product-fade-in")
          fragment.appendChild(p)
        })
        productGrid.appendChild(fragment)

        requestAnimationFrame(() => {
          notifyDiscountNinjaCollectionUpdated()
        })

        setTimeout(() => {
          newProducts.forEach(p => p.classList.remove("product-fade-in"))
        }, 700)

        currentPage++
      } else {
        maxPages = currentPage
      }
    } catch (err) {
      console.error("Error loading next page:", err)
    } finally {
      if (myGeneration === fetchGeneration) loading = false
    }
  }

  const handleScroll = () => {
    const scrollPos = window.scrollY + window.innerHeight
    const threshold = productGrid.offsetTop + productGrid.offsetHeight - 300
    if (scrollPos >= threshold) loadNextPage()
  }

  window.addEventListener("scroll", handleScroll, { passive: true })

  // facets.js replaces container.innerHTML on filter/sort — re-sync state
  new MutationObserver(() => {
    const newGrid = resolveGrid()
    if (!newGrid || newGrid === productGrid) return
    productGrid = newGrid
    currentPage = 1
    maxPages = Number(container.querySelector(".eosh-total-pages")?.value)
    fetchGeneration++
    loading = false
    initOrderTracking()
    requestAnimationFrame(() => {
      notifyDiscountNinjaCollectionUpdated()
      handleScroll()
    })
  }).observe(container, { childList: true })
}

document.addEventListener("DOMContentLoaded", initInfiniteScroll)
